module.exports = __webpack_public_path__ + "assets/4bfab8c4372cf63d072aa07401aef5df.mp4";